/**
 * @file 工具函数入口
 * @date 2022-06-21 12:35:11
 */

/**
 * 在jsx中转换dx为vw
 * @param {number} width dx宽度
 * @returns {string} vw宽度
 */
export function convertDXToVW(width) {
  return `calc(100vw / 120 * ${width} / 16)`;
}

/**
 * 判断是否为ios设备（需要运行时执行）
 * @returns {boolean}
 */
export function isIOS() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}

/**
 * 判断是否为移动端页面（需要运行时执行）
 * @returns {boolean} 是否为移动端
 */
export function isMobile() {
  return window.location.pathname.startsWith('/m');
}

/**
 * 是否是7天内新闻
 * @param {string | number} timestamp
 * @returns {boolean}
 */
export const isLatestNews = (timestamp) => {
  if (!timestamp) return false;
  const aWeekAgo = new Date().valueOf() - 604800000;
  return (() => {
    const time = new Date(timestamp).valueOf();
    return time > aWeekAgo;
  })();
};
